
"use client";
import React, { useState, useEffect, useMemo } from "react";
import modalStyles from "../../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/generic-popup.module.css";
import Button from "../../../../components/Button";
import Table from "../../../../components/Table";

const GenericPopup = ({ onClose, title = "Details", columns, data }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const sortedData = useMemo(() => {
    const parsePrice = (p) => {
      if (p == null) return Number.POSITIVE_INFINITY;
      const s = String(p).replace(/[^0-9.]/g, '');
      const n = Number(s);
      return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
    };
    const arr = Array.isArray(data) ? [...data] : [];
    arr.sort((a, b) => parsePrice(a?.costPrice) - parsePrice(b?.costPrice));
    return arr;
  }, [data]);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => onClose(), 300);
  };

  return (
    <div
      className={`${modalStyles.modalOverlay} 
        ${isVisible ? modalStyles.show : ""} 
        ${isClosing ? modalStyles.hide : ""}`}
    >
      <div className={`${modalStyles.modalContent} ${styles.modalContent}`}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalHeading}>{title}</h2>
          <button className={modalStyles.closeButton} onClick={handleClose}>
            &times;
          </button>
        </div>
        <Table columns={columns} data={sortedData} />
        <div className={styles.buttonContainer}>
          <Button onClick={handleClose} variant="secondary">
            Ignore Substitute
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GenericPopup;
